export const artist_stream_data = {
		total: {
			streams: '2.9M',
			performance: '+2900% last 28days'
		},
		spotify: {
			streams: '289K',
			performance: '+2317% last 28days'
		},
		tiktok: {
			streams: '1.2M',
			performance: '+509% last 28days'
		},
		youtube: {
			streams: '704M',
			performance: '+232% last 28days'
		}
}


export const artist_temp_skills = [
	'ARTIST',
	'PRODUCER',
	'DRUMMER',
	'BASSIST',
	'KEYBOARDIST',
	'VOCALIST',
	'SOLO ARTIST',
	'BAND ARITST'
]

export const artist_temp_traits = [
	'NEW YORK CITY',
	'DRUM STEMS',
	'CONCERT PERFORMER',
	'TOURING SINCE 2014',
	'ALTERNATIVE',
	'FUNK',
	'POP',
	'BILLBOARD TOP 100',
	'GLAM ROCK',
	'ELECTRONIC POP',
	'COLLABORATOR',
	'WEB2',
	'WEB3',
	'HARD-HITTING',
	'STEMS',
	'GAMING SYNCS',
	'POAP ACTIVATIONS',
	'NYC NATIVE',
	'SF NATIVE'
]
